import { FC } from 'react';
import colors from 'styles/_colors.module.scss';

const AboutLocation: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="81"
    height="80"
    fill="none"
    viewBox="0 0 81 80"
  >
    <path
      fill={colors['--green-500']}
      d="M57.447 34.429a16.714 16.714 0 00-33.429 0c0 6.856 5.486 15.793 16.714 26.497 11.229-10.704 16.715-19.64 16.715-26.497zM40.732 66c-13.62-12.38-20.428-22.906-20.428-31.571a20.429 20.429 0 0140.857 0c0 8.665-6.808 19.191-20.429 31.571z"
    />
    <path
      stroke={colors['--green-500']}
      strokeWidth="3"
      d="M1.804 1.5H78.804V78.5H1.804z"
    />
  </svg>
);

export default AboutLocation;
